var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2246_3977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 2.00033H7.6475L5.1475 0.666992H1.875C1.37772 0.666992 0.900805 0.877706 0.549175 1.25278C0.197544 1.62785 0 2.13656 0 2.66699L0 15.3337H15V4.00033C15 3.46989 14.8025 2.96118 14.4508 2.58611C14.0992 2.21104 13.6223 2.00033 13.125 2.00033ZM1.875 2.00033H4.8525L7.3525 3.33366H13.125C13.2908 3.33366 13.4497 3.4039 13.5669 3.52892C13.6842 3.65395 13.75 3.82351 13.75 4.00033V4.58766L1.25 4.66299V2.66699C1.25 2.49018 1.31585 2.32061 1.43306 2.19559C1.55027 2.07056 1.70924 2.00033 1.875 2.00033ZM1.25 14.0003V5.99633L13.75 5.92099V14.0003H1.25Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2246_3977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.2e255ed7a818e738640c0479b347672f.svg";
export { ForwardRef as ReactComponent };